
























import {Component, Emit, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import EventUser from '@/models/EventUser'

@Component
export default class EventUserList extends VueBase {
  @Prop(Array) readonly eventUsers!: Array<EventUser>
  @Prop({ type: Array, default: [] }) readonly value!: Array<number>

  @Emit('input')
  input(value: Array<number>): Array<number> {
    return value
  }

  get internalValue(): Array<number> {
    return this.value
  }

  set internalValue(value: Array<number>) {
    this.input(value)
  }
}
